var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultiPriorityIcon = function SvgMultiPriorityIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13536_16308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0011 17.5L9.99272 17.4992C14.1344 17.4992 17.4927 14.1409 17.4927 9.99919C17.4927 5.84919 14.1344 2.49919 9.99272 2.49086C5.84272 2.48253 2.49272 5.84086 2.48439 9.98253V9.97419C2.47606 14.1159 5.83439 17.4742 9.97606 17.4742L10.0011 17.5Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.5L10 7L11.5 8.5",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.5L10 13L11.5 11.5",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13536_16308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export { SvgMultiPriorityIcon as ReactComponent };
export default __webpack_public_path__ + "multi-priority-icon.svg";